import { attr } from '@ember-data/model';
import { buildValidations, validator } from 'ember-cp-validations';
import { dasherize } from '@ember/string';
import { A as emberA } from '@ember/array';
import StripePaymentInstrumentMixin from 'client-portal/mixins/polymorphic/stripe-payment-instrument';
import Super from 'ember-simplepractice/models/stripe-card';

export const EPHEMERAL_ATTRS = ['name', 'addressZip'];

export const SUPPORTED_BRANDS = [
  'Visa',
  'MasterCard',
  'Discover',
  'American Express',
  'JCB',
  'Diners Club',
];

const Validations = buildValidations({
  name: [
    validator('presence', {
      presence: true,
      ignoreBlank: true,
      descriptionKey: 'errors.card.cardholderName',
      messageKey: 'errors.presence',
    }),
  ],
});

export default class Card extends Super.extend(StripePaymentInstrumentMixin, Validations) {
  @attr() paymentMethodId;
  @attr() customStripeCustomerId;

  get isLinkBankAccount() {
    return this.brand?.toLowerCase() === 'link' && this.last4 === '0000';
  }

  get infoString() {
    if (this.isLinkBankAccount) {
      return 'Link - Bank Account';
    }
    return `${this.brand} *${this.last4}, expires ${this.expMonth}/${this.expYear}`;
  }

  get iconName() {
    if (this.isLinkBankAccount) {
      return 'generic-credit-card';
    }

    let brand = this.brand;

    if (!SUPPORTED_BRANDS.includes(brand)) {
      return 'generic-credit-card';
    }

    if (brand.includes(' ')) {
      brand = dasherize(brand);
    }

    return `${brand.toLowerCase()}-card`;
  }

  static fieldsFor(_context) {
    let fields = emberA();
    this.fields.forEach((_, v) => fields.pushObject(v));
    fields.removeObject('meta');
    fields.removeObjects(['addressZip', 'name']);
    return fields;
  }
}
